<style scoped>
.v-application .subtitle-1 {
  font-size: 14px !important;
  font-weight: normal;
  letter-spacing: 0.009375em !important;
  line-height: 1.75rem;
  font-family: "Prompt", sans-serif !important;
}
</style>

<template>
  <v-menu offset-y absolute>
    <template v-slot:activator="{ on }">
      <v-btn
        outlined
        color="black"
        elevation="0"
        small
        class="mb-0"
        style="width: 30px; min-width: 35px"
        v-on="on"
        @click="menu_list()"
      >
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list subheader>
      <v-list-item
        v-for="(item, i) in subMenu"
        :key="i"
        @click="menu_action(item)"
        class="mb-n3 mt-n1 mx-n1"
      >
        <v-list-item-avatar style="width: 20px; min-width: 20px">
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="my-n5 subtitle-1">{{
            item.title
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  name: "TableMenuProduct",
  props: {
    TableData: Object,
  },
  data: () => ({
    subMenu: [
      { icon: "mdi-file-document-edit-outline", title: 'แก้ไขสินค้า' },
      // { icon: "mdi-content-copy", title: 'สร้างซ้ำ' },
      { icon: "mdi-trash-can-outline", title: 'ลบสินค้า' }
    ],
  }),
  created() {

  },
  methods: {
    menu_list(item) {
      let pid = this.TableData.PID
      let menu_arr = this.subMenu
      if (pid == 28 || pid == 29 || pid == 30 || pid == 19 || pid == 20 || pid == 21 || pid == 106 || pid == 107 || pid == 108 || pid == 109 || pid == 115 || pid == 111 || pid == 112 || pid == 113 || pid == 114 || pid == 110 || pid == 40 || pid == 43 || pid == 44 || pid == 41 || pid == 42 || pid == 101) {
        let newMenu = menu_arr.filter((x) => {
          return x.title != 'ลบสินค้า'
        })
        this.subMenu = newMenu
      } else {

      }


    },

    menu_action(item) {

      if (item.title == "แก้ไขสินค้า") {
        let pid =this.TableData.PID
        console.log(pid == 28 || pid == 29 || pid == 30 || pid == 19 || pid == 20 || pid == 21 || pid == 106 || pid == 107 || pid == 108 || pid == 109 || pid == 115 || pid == 111 || pid == 112 || pid == 113 || pid == 114 || pid == 110 || pid == 40 || pid == 43 || pid == 44 || pid == 41 || pid == 42 || pid == 101)
        if(pid == 28 || pid == 29 || pid == 30 || pid == 19 || pid == 20 || pid == 21 || pid == 106 || pid == 107 || pid == 108 || pid == 109 || pid == 115 || pid == 111 || pid == 112 || pid == 113 || pid == 114 || pid == 110 || pid == 40 || pid == 43 || pid == 44 || pid == 41 || pid == 42 || pid == 101){
           this.$parent.$parent.$parent.$parent.is_disabled = true
        }else{
           this.$parent.$parent.$parent.$parent.is_disabled = false
        }
       
        this.$store.commit('Product/SET_IS_EDIT', true)
        this.$token_api.post('list-product-by-id', { id: this.TableData.PID })
          .then((response) => {
            this.$store.commit('Product/SET_ALL_ELEMENT', response.data.data[0])
            this.$parent.$parent.$parent.$parent.dialog = true

          })
          .catch((error) => {
            console.log(error);
          });
      } else if (item.title == "ลบสินค้า") {
        this.$swal({
          title: "ต้องการลบข้อมูลหรือไม่",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
          .then((result) => {
            if (result.value) {
              this.$token_api
                .delete("/delete-product", { data: { pro_id: this.TableData.PID } })
                .then((response) => {
                  this.$parent.$parent.$parent.$parent.listProduct()

                })
                .catch((error) => {
                  console.log(error);
                });

            }
          });
      } else if (item.title == "สร้างซ้ำ") {

      }
    }

  }
};
</script>

